import "../../css/components/ai-summary.scss";

const selector = "[data-ai-summary]";

function closeSummary(summary) {
  summary
    .querySelector("[data-ai-summary-toggle]")
    .setAttribute("aria-expanded", "false");
  summary.querySelector(".ai-summary__dropdown").hidden = true;
}

document.addEventListener("click", event => {
  const target = event.target;
  if (!(target instanceof Element)) {
    return;
  }

  const toggle = target.closest("[data-ai-summary-toggle]");
  const current = target.closest(selector);
  const shouldOpen =
    toggle && current && current.querySelector(".ai-summary__dropdown").hidden;

  document.querySelectorAll(selector).forEach(summary => {
    if (summary !== current || toggle || target.closest(".ai-summary__link")) {
      closeSummary(summary);
    }
  });

  if (toggle && current) {
    const dropdown = current.querySelector(".ai-summary__dropdown");
    dropdown.hidden = !shouldOpen;
    toggle.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
  }
});

document.addEventListener("keydown", event => {
  if (event.key !== "Escape") {
    return;
  }

  const open = document.querySelector(
    `${selector} [data-ai-summary-toggle][aria-expanded="true"]`
  );
  if (!open) {
    return;
  }

  document.querySelectorAll(selector).forEach(closeSummary);
  open.focus();
  event.preventDefault();
});
